export const updateMixin = {
  watch: {
    '$i18n.locale' () {
      this.updateScroll(1000)
      this.scrollTop('body', 0)
    }
  }
}
